import { slug } from '@/helpers/urlTs';
import { DEFAULT_MY_LOCATION_KEYWORD } from '@/hooks/search/useSearch.constants';
import { TabIdentifier } from '../MegaMenu.constants';
import { TabIdentifier as Identifier } from '../MegaMenu.types';

function createLink(keyword, location = DEFAULT_MY_LOCATION_KEYWORD) {
  return `/${slug(keyword)}/${slug(location)}`;
}

export function getDefaultSEOContentCtaLink(identifier: Identifier) {
  switch (identifier) {
    case TabIdentifier.Hairdresser:
      return createLink('Frisör');
    case TabIdentifier.Massage:
      return createLink('Massage');
    case TabIdentifier.Nails:
      return createLink('Naglar');
    case TabIdentifier.Lashes:
      return createLink('Fransar');
    case TabIdentifier.Skincare:
      return createLink('Hudvård');
    case TabIdentifier.Beauty:
      return createLink('Skönhet');
    case TabIdentifier.Health:
      return createLink('Hälsa');
    default:
      return '/';
  }
}
